import { IRangeConflict, TRulesManipulationError } from './../types/e-visits.d';

export function isRangeError(error: TRulesManipulationError): error is IRangeConflict {
  return error && 'detail' in error && 'conflicts' in error.detail;
}
